module.exports = __webpack_public_path__ + "img/SES_235416300.fe8cf6e7.jpg";